import React, { useState } from 'react';
import { Button, Space } from '@cashfree-intl/coherent';

import { DEFAULT_LIMIT_OPTIONS } from 'utils/constants';

import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import { HEADINGS } from '../constants';

const PaymentMethodRateTable = ({
  filters,
  hasPrev,
  hasNext,
  onPageChange,
  onLimitChange,
  rowData,
  isLoading,
  onUpdateClick,
}: any) => {
  const [selectedRecordIds, setSelectedRecordIds] = useState({});

  const FORMATTED_COLUMN_ID = formatColumns(HEADINGS);

  const combinedColumn = {
    accessorKey: 'status',
    header: 'TDR Status',
    ellipsis: true,
    cell: ({ status, toggle }) => (
      <Space alignItems="center" justifyContent="space-between">
        {status()}
        {toggle()}
      </Space>
    ),
  };

  const updatedColumnId = [...FORMATTED_COLUMN_ID.slice(0, -3), combinedColumn];

  const rowSelectionInfo = {
    primaryKey: 'id',
    selectedRecordIds,
    onChange: row => {
      setSelectedRecordIds(row);
    },
    renderRowSelectionAction: () => (
      <Button
        primary
        onClick={onUpdateClick}
        data-event-name="Primary_Button_Update"
        data-ignore-inner-text="true"
      >
        Update{' '}
        {
          Object.keys(selectedRecordIds).filter(key => !!selectedRecordIds[key])
            .length
        }{' '}
        Items
      </Button>
    ),
  };

  return (
    <PaginatedTable
      data={rowData}
      tableHeading={updatedColumnId}
      limit={filters.pageSize}
      limitOptions={DEFAULT_LIMIT_OPTIONS}
      hasPrev={hasPrev}
      hasNext={hasNext}
      currentPage={filters.pageNo}
      currentPageCount={rowData.length}
      onPageChange={onPageChange}
      onLimitChange={onLimitChange}
      withSelect={rowSelectionInfo}
      fetching={isLoading}
    />
  );
};

export default PaymentMethodRateTable;
